import { useContext } from 'react';
import ZapisDoplnenehoStanoviskaFormDataContext, {
  ZapisDoplnenehoStanoviskaFormDataContextContent,
} from '../ZapisDoplnenehoStanoviskaFormDataContext';

export default ():
  ZapisDoplnenehoStanoviskaFormDataContextContent => useContext(ZapisDoplnenehoStanoviskaFormDataContext);
